import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Tabs, Tab } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import InvestigationTab from "./component/InvestigationTab";
import ReviewTab from "./component/ReviewTab";
import ResolutionTab from "./component/ResolutionTab";
import CAPATab from "./component/CAPA_Tab";
import FinalReportTab from "./component/FinalReportTab";
import { isEmpty } from "lodash";
import { getIncidentById } from "actions";

const tabsMeta = [
  {
    key: "review",
    title: "Incident Review",
    permissionName: "Incident Review",
    activeIcon: "/assets/images/review-active.svg",
    inactiveIcon: "/assets/images/review-inactive.svg",
    Component: ReviewTab,
  },
  {
    key: "investigation",
    title: "Incident Investigation",
    permissionName: "Incident Investigation",
    activeIcon: "/assets/images/investigation-active.svg",
    inactiveIcon: "/assets/images/investigation-inactive.svg",
    Component: InvestigationTab,
  },
  {
    key: "resolution",
    title: "Incident Resolution",
    permissionName: "Incident Resolution",
    activeIcon: "/assets/images/resolution-active.svg",
    inactiveIcon: "/assets/images/resolution-inactive.svg",
    Component: ResolutionTab,
  },
  {
    key: "capa",
    title: "CAPA",
    permissionName: "CAPA",
    activeIcon: "/assets/images/capa-active.svg",
    inactiveIcon: "/assets/images/capa-inactive.svg",
    Component: CAPATab,
  },
  {
    key: "final report",
    title: "Final Report",
    permissionName: "Final Report",
    activeIcon: "/assets/images/final-active.svg",
    inactiveIcon: "/assets/images/final-inactive.svg",
    Component: FinalReportTab,
  },
];

const IncidentForm = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const session = useSelector((state) => state.session);

  const incidentState = useSelector((state) => state.incidentState);

  const permissionsRaw = session?.user_permissions_raw || {};

  const hasViewPermission = (permissionName) => {
    return Object.values(permissionsRaw).some(
      (perm) =>
        perm.name?.toLowerCase() === permissionName.toLowerCase() &&
        String(perm.rights_view) === "1"
    );
  };

  const accessibleTabs = tabsMeta.filter((tab) =>
    hasViewPermission(tab.permissionName)
  );

  const [activeKey, setActiveKey] = useState(() =>
    accessibleTabs.length > 0 ? accessibleTabs[0].key : ""
  );
  const [incidentId, setIncidentId] = useState(null);
  const [loadFromBack, setLoadFromBack] = useState(false);
  const [previousData, setPreviousData] = useState({});
  const [severityLevelMap, setSeverityLevelMap] = useState({});


  useEffect(() => {
    if (
      location.pathname === "/incidentForm/edit" ||
      location.pathname === "/scopeIncident/edit"
    ) {
      if (incidentState.showUpdateForm) {
        if (!isEmpty(incidentState.incidentRecord)) {
          let incidentFormObj = incidentState.incidentRecord;
          setIncidentId(incidentFormObj.id);
          setPreviousData(incidentFormObj);
        }
      } else {
        // 🚨 only redirect if no incident is already loaded
        if (isEmpty(previousData)) {
          if (location.pathname === "/incidentForm/edit") {
            navigate("/incidentForm");
          } else {
            navigate("/scopeIncident");
          }
        }
      }
    }
  }, [
    incidentState.showUpdateForm,
    incidentState.incidentRecord,
    location.pathname,
    navigate,
    previousData,
  ]);

  useEffect(() => {
    if (incidentState.redirect_to_list) {
      if (location.pathname === "/incidentForm/edit") {
        navigate("/incidentForm");
      } else {
        navigate("/scopeIncident");
      }
    }
  }, [incidentState.redirect_to_list]);

  useEffect(() => {
    // Only run on edit
    if (
      (location.pathname === "/incidentForm/edit" ||
        location.pathname === "/scopeIncident/edit") &&
      !isEmpty(previousData)
    ) {
      const tabKey = localStorage.getItem("incidentActiveTab");
      if (tabKey && accessibleTabs.some((tab) => tab.key === tabKey)) {
        setActiveKey(tabKey);
        localStorage.removeItem("incidentActiveTab");
      }
    }
  }, [previousData, location.pathname, accessibleTabs]);

  useEffect(() => {
    let incidentFormObj = incidentState.incidentRecord;

    setIncidentId(incidentFormObj.id);
    setPreviousData(incidentFormObj);
  }, [incidentState.incidentRecord]);

  const goToNextTab = () => {
    const currentIndex = accessibleTabs.findIndex(
      (tab) => tab.key === activeKey
    );
    if (currentIndex < accessibleTabs.length - 1) {
      setActiveKey(accessibleTabs[currentIndex + 1].key);
    }
  };

  const goToPreviousTab = async () => {
    const currentIndex = accessibleTabs.findIndex(
      (tab) => tab.key === activeKey
    );

    if (currentIndex > 0 && incidentId) {
      try {
        // Fetch fresh data
        // const response = await dispatch(getIncidentById(incidentId, 'update'));

        // // Extract updated incident data
        // const updatedIncident =
        //   response?.data || // if your action returns a promise with response
        //   incidentState.incidentRecord; // fallback to Redux state

        // if (updatedIncident) {
        //   setPreviousData(updatedIncident); // <-- Update immediately
        // }

        // Switch tab
        setLoadFromBack(true);
        setActiveKey(accessibleTabs[currentIndex - 1].key);
      } catch (error) {
        console.error("Failed to fetch incident data:", error);
      }
    }
  };

  useEffect(() => {
    if (activeKey === "final report" && incidentId) {
      // (async () => {
      //   try {
      //     const response = await dispatch(getIncidentById(incidentId, 'update'));
      //     const updatedIncident =
      //       response?.data || incidentState.incidentRecord;
      //     if (updatedIncident) {
      //       setPreviousData(updatedIncident);
      //     }
      //   } catch (error) {
      //     console.error(
      //       "Failed to fetch incident data for final report:",
      //       error
      //     );
      //   }
      // })();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeKey, incidentId]);

  return (
    <>
      {!isEmpty(previousData) ? (
        <div className="incident-form-tab">
          {/* Tabs */}
          <Tabs
            activeKey={activeKey}
            onSelect={(k) => setActiveKey(k)}
            className="justify-content-center border-bottom-0 form-tabs"
          >
            {accessibleTabs.map(({ key, title, activeIcon, inactiveIcon }) => (
              <Tab
                key={key}
                eventKey={key}
                className="text-center"
                disabled={
                  location.pathname === "/incidentForm/edit"
                    ? !previousData.completion[key]
                    : false
                }
                title={
                  <>
                    <img
                      src={activeKey === key ? activeIcon : inactiveIcon}
                      className="tab-icon mb-3"
                      alt=""
                    />
                    {title}
                  </>
                }
              />
            ))}
          </Tabs>

          {/* Tab Content */}
          <div className="mt-3 p-4">
            {accessibleTabs.map(({ key, Component }) =>
              key === activeKey ? (
                <Component
                  key={activeKey}
                  incidentId={incidentId}
                  setIncidentId={setIncidentId}
                  onNext={goToNextTab}
                  onBack={goToPreviousTab}
                  loadFromBack={loadFromBack}
                  setLoadFromBack={setLoadFromBack}
                  previousData={previousData}
                  goToFinalReport={() => setActiveKey("final report")}
                  
                />
              ) : null
            )}
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default IncidentForm;
